import React, { useContext, useEffect, useState } from 'react'
import { Container } from '@orbitalgaming/games-frontend-library'
import { Main } from '../provably/ProvablyStyle'
import PageHeader from '../header/Header'
import Table from './components/Table'
import Tabs from './components/Tabs'
import { History_props } from './interface'
import { cyberColors } from '../../lib/colors'
import { MyContext } from '../../context/createContext'

export default function History({
  history,
  handleAbove,
  requestBetReply,
  handleRoundId,
  handlePopup,
  audio,
  prec,
}: History_props) {
  const [active, setActive] = useState<string>('my bets')
  const [activeTable, setActiveTable] = useState<any>(history.my)

  useEffect(() => {
    active === 'my bets'
      ? setActiveTable(history.my)
      : active === 'all bets'
      ? setActiveTable(history.all)
      : setActiveTable(history.high)
  }, [active])

  const handleActive = (s: string) => setActive(s)

  return (
    <Container backgroundColor={cyberColors.black} padding={'21px 30px 10px'}>
      <PageHeader
        title={'history'}
        func={() => handleAbove(false)}
        audio={audio}
      />
      <Tabs active={active} handleActive={handleActive} />
      <Main margin={'0 0 20px'}>
        <Table
          activeTable={activeTable}
          requestBetReply={requestBetReply}
          handleRoundId={handleRoundId}
          handlePopup={handlePopup}
          prec={prec}
        />
      </Main>
    </Container>
  )
}
